import gql from 'graphql-tag';

export const guidedCourseNextStepsQuery = gql`
  query courseNextStep($ids: String!, $stepsToSkip: String) {
    GuidedCourseNextStepsV1 @naptime {
      multiGet(ids: $ids, stepsToSkip: $stepsToSkip) {
        elements {
          id
          nextStep
        }
      }
    }
  }
`;

export default guidedCourseNextStepsQuery;
